"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

function _default(name) {
  return "function ".concat(name, "(ctx) {\n  \n}");
}

module.exports = exports.default;